module.exports = __webpack_public_path__ + "static/media/car-1-acacia.15fdde0f.png";